import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DsButtonComponent } from "src/app/ui/design-system/button/button.component";

@Component({
  standalone: true,
  selector: 'app-cookie-consent',
  imports: [DsButtonComponent, CommonModule, TranslateModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss'
})
export class CookieConsentComponent implements OnInit {
  showBanner = false;

  private readonly platformId = inject(PLATFORM_ID);

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Verifica se o usuário já aceitou os cookies
    const cookieConsent = localStorage.getItem('cookie-consent');
    if (!cookieConsent) {
      // Mostra o banner após um pequeno delay para melhor UX
      setTimeout(() => {
        this.showBanner = true;
      }, 1000);
    }
  }

  acceptCookies(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Salva o consentimento no localStorage
      localStorage.setItem('cookie-consent', 'accepted');
      localStorage.setItem('cookie-consent-date', new Date().toISOString());
    }

    // Esconde o banner
    this.showBanner = false;
  }

  goToPrivacyPolicy(): void {
    this.router.navigate(['/privacy-policy']);
  }
}
